import {
	fetchLandingTilesSuccess,
	fetchLandingSettingsSuccess,
	IFantasyTile,
	ILandingSettings,
	updateStatusFilter,
	toggleFilter,
	IFantasyTeam,
	fetchFullTeamSuccess,
	selectTile,
} from "modules/actions";
import {createReducer} from "redux-act";

export interface IFantasyTilesReducer {
	tiles: IFantasyTile[];
	selectedTile: number | null;
	settings: ILandingSettings | null;
	statusFilter: string[];
	isFiltersOpen: boolean;
	team: IFantasyTeam | undefined;
}

const defaultState: IFantasyTilesReducer = {
	tiles: [],
	selectedTile: null,
	settings: null,
	statusFilter: ["all"],
	isFiltersOpen: false,
	team: undefined,
};

const fetchFantasyTilesHandler = (state: IFantasyTilesReducer, payload: IFantasyTile[]) => ({
	...state,
	tiles: payload,
});

const fetchLandingSettingsHandler = (state: IFantasyTilesReducer, payload: ILandingSettings) => ({
	...state,
	settings: payload,
});

const updateStatusFilterHandler = (state: IFantasyTilesReducer, payload: string[]) => ({
	...state,
	statusFilter: payload,
});

const toggleFilterHandler = (state: IFantasyTilesReducer, payload: boolean) => ({
	...state,
	isFiltersOpen: payload,
});

const fetchFullTeamSuccessHandler = (state: IFantasyTilesReducer, payload: IFantasyTeam) => ({
	...state,
	team: payload,
});

const onSelectTile = (state: IFantasyTilesReducer, payload: number | null) => ({
	...state,
	selectedTile: payload,
});

export const fantasyTiles = createReducer<typeof defaultState>({}, defaultState)
	.on(fetchLandingTilesSuccess, fetchFantasyTilesHandler)
	.on(fetchLandingSettingsSuccess, fetchLandingSettingsHandler)
	.on(updateStatusFilter, updateStatusFilterHandler)
	.on(toggleFilter, toggleFilterHandler)
	.on(fetchFullTeamSuccess, fetchFullTeamSuccessHandler)
	.on(selectTile, onSelectTile);
